<template>
    <div class="access-denied">
      <h1>Acceso Denegado</h1>
      <p>No tienes permiso para acceder a esta página.</p>
      <button @click="goBack">Volver</button>
    </div>
  </template>

  <script>
  export default {
    name: 'AccessDenied',
    methods: {
      goBack() {
        this.$nextTick(() => {
          let user_data = JSON.parse(localStorage.getItem('user'));
          if(user_data.tipo_usuario == 'CUATRIMESTRE'){
            this.$router.push({ name: "Dashboard" });
          }else{
            this.$router.push({ name: "Comprobantes" });
          }
            // Regresa a la página anterior
            //history.back();
        });
    }
    }
  };
  </script>

  <style scoped>
  .access-denied {
    text-align: center;
    margin-top: 50px;
  }
  button {
    padding: 10px 20px;
    background-color: #42b983;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 16px;
  }
  button:hover {
    background-color: #369670;
  }
  </style>
